document.addEventListener('DOMContentLoaded', function () {
    const stickyAnchorMenu = document.querySelector('.js-sticky-anchor-menu');
    if (!stickyAnchorMenu) return;

    const anchorLinks = stickyAnchorMenu.querySelectorAll('.js-anchor-link');

    anchorLinks.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const target = document.querySelector(link.getAttribute('href'));
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 100,
                    behavior: 'smooth'
                });
            }
        });
    });

    checkCurrentAnchor();
});

window.addEventListener('scroll', throttle(() => {
    checkCurrentAnchor();
    toggleStickyAnchorVisibility();
}, 100));

function checkCurrentAnchor() {
    const stickyAnchorMenu = document.querySelector('.js-sticky-anchor-menu');
    if (!stickyAnchorMenu) return;

    const anchorLinks = Array.from(stickyAnchorMenu.querySelectorAll('.js-anchor-link'));
    let activeLink = null;

    for (let i = anchorLinks.length - 1; i >= 0; i--) {
        const link = anchorLinks[i];
        const target = document.querySelector(link.getAttribute('href'));
        if (target && window.scrollY >= target.offsetTop - 200) {
            activeLink = link;
            break;
        }
    }

    anchorLinks.forEach(link => link.classList.remove('active'));
    if (activeLink) activeLink.classList.add('active');
}

function toggleStickyAnchorVisibility() {
    const stickyAnchorMenu = document.querySelector('.js-sticky-anchor-menu');
    if (!stickyAnchorMenu || !window.matchMedia("(min-width: 990px)").matches) return;

    const footerGroups = document.querySelectorAll('.shopify-section-group-footer-group');
    let isHidden = false;

    for (const footerGroup of footerGroups) {
        if (!footerGroup) continue;
        const footerRect = footerGroup.getBoundingClientRect();
        if (footerRect.top <= window.innerHeight && footerRect.bottom >= 0) {
            isHidden = true;
            break;
        }
    }

    if (isHidden) {
        stickyAnchorMenu.classList.add('hidden');
    } else {
        stickyAnchorMenu.classList.remove('hidden');
    }
}

// Throttle function to improve performance
function throttle(func, limit) {
    let lastFunc, lastRan;
    return function () {
        const context = this, args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}
